(function () {
  function initDescriptionClamp(scope) {
    var root = scope || document;
    var clamps = root.querySelectorAll('[data-frk-description-clamp]');

    clamps.forEach(function (clamp) {
      var wrapper = clamp.closest('.m-collapsible--content');
      var toggle = wrapper ? wrapper.querySelector('[data-frk-description-toggle]') : null;

      if (!toggle || toggle.dataset.frkClampBound === 'true') return;

      function checkOverflow() {
        var wasCollapsed = clamp.classList.contains('is-collapsed');

        clamp.classList.add('is-collapsed');

        window.requestAnimationFrame(function () {
          var hasOverflow = clamp.scrollHeight > clamp.clientHeight + 12;

          toggle.classList.toggle('is-visible', hasOverflow);

          if (!hasOverflow) {
            clamp.classList.remove('is-collapsed');
          } else if (!wasCollapsed && toggle.getAttribute('aria-expanded') === 'true') {
            clamp.classList.remove('is-collapsed');
          }
        });
      }

      toggle.addEventListener('click', function () {
        var isCollapsed = clamp.classList.toggle('is-collapsed');

        toggle.setAttribute('aria-expanded', String(!isCollapsed));
        toggle.textContent = isCollapsed ? 'See more' : 'See less';
      });

      toggle.dataset.frkClampBound = 'true';

      setTimeout(checkOverflow, 150);
      window.addEventListener('resize', checkOverflow);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDescriptionClamp(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initDescriptionClamp(event.target);
  });
})();